import { render } from "./ForeignTradeByProductsFilter.vue?vue&type=template&id=2c26894d&ts=true"
import script from "./ForeignTradeByProductsFilter.vue?vue&type=script&lang=ts"
export * from "./ForeignTradeByProductsFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__